// Entry point. The app itself lives in ./app.ts. We first make sure this browser
// has a wallet — and we NEVER create one silently: if none exists, the person
// must explicitly create or load one on the wallet gate before the app boots.
import './styles.css';
import { hasStoredWallet } from './storage/wallet.js';
import { initPwa } from './pwa.js';

initPwa();

async function boot(): Promise<void> {
  if (!hasStoredWallet()) {
    const { showWalletGate } = await import('./ui/walletGate.js');
    await showWalletGate();
  }
  await import('./app.js');
}

void boot();
